export const SHOW_VIN = 'SHOW_VIN';
export const HIDE_VIN = 'HIDE_VIN';
export const VIN_STATUS = 'VIN_STATUS';
export const RESET_VEHICLE = 'RESET_VEHICLE';
export const RESET_OUTLINE = 'RESET_OUTLINE';
export const VIN_MANUAL_CAM = 'VIN_MANUAL_CAM';
export const SHOW_VEHICLE_INFO = 'SHOW_VEHICLE_INFO';
export const DETECT_OUTLINE_VEHICLE = 'DETECT_OUTLINE_VEHICLE';
export const VIN_QR_SCANNER = 'VIN_QR_SCANNER';
export const SET_CAGES = 'SET_CAGES';
